import * as React from "react"
import { connect } from "react-redux"

import { GlobalState } from "../../../../../store"

import ActionRow from "./ActionRow"
import { TableBody } from "@tenforce/toolbox-table-react"
import bem from "../../../../../bem"
import env from "../../../../../env"
import { Symbols } from "@tenforce/toolbox-fontmap"
import { Labels } from "../../../../../util/Translations"
import { IUserInfo } from "../index"

const b = bem.with("NewUI__userMenuActions")

const applicationPath = env.applicationPath
const logoutUrl = `${applicationPath}/logout`
const profileUrl = `${applicationPath}/account/profile`
const reportsUrl = `${applicationPath}/reports`
const settingsUrl = `${applicationPath}/config`
const timesheetUrl = `${applicationPath}/timesheet`

type StateProps = IUserInfo

type Props = StateProps

const {
    Home,
    Profile,
    Timesheet,
    Reports,
    Help,
    Settings,
    PrivacyPolicy,
    Logout,
} = Labels
export const Actions = ({
    hasLogout,
    hasReports,
    hasSettings,
    hasTimesheet,
    helpUrl,
    homePageUrl,
    privacyPolicyUrl,
}: Props): JSX.Element => (
    <div className={b() + "tw-mx-2"}>
        <TableBody extraClasses="tw-mb-3">
            {homePageUrl && (
                <ActionRow
                    data-ft-usermenu="home"
                    label={Home}
                    url={homePageUrl}
                    symbol={Symbols.Home}
                />
            )}
            <ActionRow
                data-ft-usermenu="profile"
                label={Profile}
                url={profileUrl}
                symbol={Symbols.User}
            />
            {hasTimesheet && (
                <ActionRow
                    data-ft-usermenu="timesheet"
                    label={Timesheet}
                    url={timesheetUrl}
                    symbol={Symbols.Timesheet}
                />
            )}
            {hasReports && (
                <ActionRow
                    data-ft-usermenu="reports"
                    label={Reports}
                    url={reportsUrl}
                    symbol={Symbols.Reports}
                />
            )}
        </TableBody>
        <TableBody>
            {!!helpUrl && (
                <ActionRow
                    data-ft-usermenu="help"
                    label={Help}
                    url={helpUrl}
                    symbol={Symbols.Help}
                    target="_blank"
                />
            )}
            {hasSettings && (
                <ActionRow
                    data-ft-usermenu="settings"
                    label={Settings}
                    url={settingsUrl}
                    symbol={Symbols.Wrench}
                />
            )}
            <ActionRow
                data-ft-usermenu="privacy"
                label={PrivacyPolicy}
                url={privacyPolicyUrl}
                symbol={Symbols.Privacy}
            />
            {hasLogout && (
                <ActionRow
                    data-ft-usermenu="logout"
                    label={Logout}
                    url={logoutUrl}
                    symbol={Symbols.Logout}
                />
            )}
        </TableBody>
    </div>
)

const mapStateToProps = (state: GlobalState): StateProps => state.userInfo

export default connect(mapStateToProps, {})(Actions)
